import React from "react";
import "./AboutModal.css";

interface AboutModalProps {
	onClose: () => void;
}

export const AboutModal: React.FC<AboutModalProps> = ({ onClose }) => (
	<div className="aboutmodal-overlay-modal">
		<div className="aboutmodal-modal-content">
			<button
				className="aboutmodal-close-button"
				onClick={onClose}
			>
				&times;
			</button>
			<iframe
				className="aboutmodal-modal-video"
				src="https://player.vimeo.com/video/1081010002?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
				title="Bonk Story"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
				allowFullScreen
			/>
		</div>
	</div>
);
